export default __webpack_public_path__ + "84b33f339750368898914c197a80ce37.svg";